// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__8xavW","icon":"styles__icon__2GzeK","imageContainer":"styles__imageContainer__3Ps_c","titleContainer":"styles__titleContainer__3ry5f","title":"styles__title__1g64f","description":"styles__description__REJMg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductAttribute/styles.scss
// module id = 402
// module chunks = 0